import { graphql } from "@apollo/client/react/hoc";
import UPDATE_BOOKING from "./update-booking.mutation";

export default graphql(UPDATE_BOOKING, { name: "updateBooking" });
